export default "__VITE_ASSET__CC4C4yaj__"